export enum PricePerType {
    Item = 0,
    Unit = 1,
    User = 2,
    Site = 3,
}

export const PricePerTypes: IPricePerType[] = [
    { Id: PricePerType.Item, TextId: 'common.item' },
    { Id: PricePerType.Unit, TextId: 'billing.unit' },
    { Id: PricePerType.User, TextId: 'user.user' },
    { Id: PricePerType.Site, TextId: 'site' },
];

export interface IPricePerType {
    Id: PricePerType;
    TextId: string;
}
